let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fWxRi")).then(() => parcelRequire('9nmea'));